const getMaximumMinimumValue = (...values: Array<number | undefined>): number | undefined => {
  const validValues = values.filter((value): value is number => value !== undefined && value > 0);
  return validValues.length > 0 ? Math.max(...validValues) : undefined;
};

export const clampToMax = (value: number | null, max: number | null): number | null =>
  value != null && max != null && value > max ? max : value;

export type DimensionFieldName = "base" | "height" | "secondaryBase" | "secondaryHeight";

export type DimensionBounds = {
  min?: number;
  max?: number;
};

export type DimensionBoundsInput = {
  base: number | null;
  height: number | null;
  secondaryBase: number | null;
  secondaryHeight: number | null;
};

// base must stay strictly greater than secondaryBase (and height than secondaryHeight) - an L-shape
// where the outer side is no bigger than the cutout notch isn't a valid shape. Expressed as a small
// gap rather than a separate "exclusive bound" concept so every caller can keep comparing with a
// plain >= / <=, at the same 3-decimal (mm) precision these fields already use.
const MIN_DIMENSION_GAP = 0.001;

// The same base/height/secondaryBase/secondaryHeight limits enforced by the ShapeAndSizeCard form
// fields - shared so plane-driven edits (drag-resize, type-to-edit) reject the same values.
export const getDimensionBounds = (fieldName: DimensionFieldName, input: DimensionBoundsInput): DimensionBounds => {
  switch (fieldName) {
    case "base":
      return {
        min: getMaximumMinimumValue(input.secondaryBase != null ? input.secondaryBase + MIN_DIMENSION_GAP : undefined),
      };
    case "height":
      return {
        min: getMaximumMinimumValue(
          input.secondaryHeight != null ? input.secondaryHeight + MIN_DIMENSION_GAP : undefined,
        ),
      };
    case "secondaryBase":
      return {
        min: getMaximumMinimumValue(0.01),
        max: input.base != null ? input.base - MIN_DIMENSION_GAP : undefined,
      };
    case "secondaryHeight":
      return {
        min: getMaximumMinimumValue(0.01),
        max: input.height != null ? input.height - MIN_DIMENSION_GAP : undefined,
      };
  }
};
